<template>
<div>
  <v-row>
    <v-col
      v-if="ticket.technologyType != 'FTTC'"
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <v-radio-group
        row
        v-model="ticket.cpePowercycled"
      >
        <label class="mr-2">Has the CPE been powercycled?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col
      v-if="ticket.technologyType != 'FTTC'"
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <v-radio-group
        row
        v-model="ticket.cpeAlternateTest"
      >
        <label class="mr-2">Has an alternate CPE been tested?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col
      v-if="ticket.technologyType != 'FTTC'"
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <v-radio-group
        row
        v-model="ticket.incidents"
      >
        <label class="mr-2">Any active incidents at time of fault?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>


    <v-col
      v-if="!hasNoIsolationTest"
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <v-radio-group
        row
        v-model="ticket.isolationTest"
      >
        <label class="mr-2">Has an isolation test been run?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>


    <nbn-check-list-details-fibre v-if="ticket.technologyType == 'Fibre'" :ticket="ticket"></nbn-check-list-details-fibre>
    <nbn-check-list-details-fttc v-if="ticket.technologyType == 'FTTC'" :ticket="ticket"></nbn-check-list-details-fttc>
    <nbn-check-list-details-hfc v-if="ticket.technologyType == 'HFC'" :ticket="ticket"></nbn-check-list-details-hfc>
    <nbn-check-list-details-wireless v-if="ticket.technologyType == 'Fixed Wireless'" :ticket="ticket"></nbn-check-list-details-wireless>
    <nbn-check-list-details-fttn-fttb v-if="ticket.technologyType == 'FTTN' || ticket.technologyType == 'FTTB'" :ticket="ticket"></nbn-check-list-details-fttn-fttb>
  </v-row>
</div>
</template>

<script>
export default {
  name: "nbn-check-list-details",
  props: {
    ticket: { type: Object },
  },
  computed: {
    hasNoIsolationTest() {
      let vm =this;
      return (vm.ticket.technologyType == 'FTTN' || vm.ticket.technologyType == 'FTTB') &&
        (vm.ticket.category == 'New service never worked' || vm.ticket.category == 'No data connection'
          || vm.ticket.category == 'Other' || vm.ticket.category == 'Dispute - Potential Performance Incident'
          || vm.ticket.category == 'Dispute - Potential Service Fault')
    }
  }
}
</script>

<style scoped>

</style>
